<template>
    <div>
        <custom-export-category-form
            :entity-id="entityId"
        ></custom-export-category-form>
    </div>
</template>

<script>
import customExportCategoryForm from '@/components/pages/customExportCategory/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        customExportCategoryForm,
    },

    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },

    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.id
            },
        },
    },
}
</script>
